import React, { useCallback, useContext, useEffect, useState } from 'react'
import SearchContext from '../context/SearchContext'


const MobileFilter = () => {
    const {toggleShowFilterInMobile, params, handleParams} = useContext(SearchContext)
    const [showCount, setShowCount] = useState(false)


    const countActiveParams = useCallback(()=>{
        let numberOfActive = []
        Array.from(params.entries()).forEach(([key, value]) => {
            // dont count this
            if( ['sort','query'].includes(key)) {  return }

            let splitter = ', ';
            if( key === 'keywords') { splitter = ' '}

            numberOfActive = [ ...value.split(splitter), ...numberOfActive]
        })
        setShowCount( numberOfActive.length );

        return numberOfActive.length
    },[params])

    useEffect(()=>{
        countActiveParams()
    },[params, countActiveParams])

    return (
        <div className="mobil-filter-toggle">
            <a 
                href="#visa-filter" 
                onClick={(e)=>{ e.preventDefault(); toggleShowFilterInMobile()} } 
                className="filter-btn" 
                title="Visa filter"
            >
                { showCount > 0 &&
                    <span className="filter-count">{showCount}</span>
                }
                Bilfilter
            </a>
            { showCount > 0 &&
                <a 
                    href="#aterstall-filter" 
                    title="Återställ filter"
                    className="filter-reset"
                    onClick={(e)=>{
                        e.preventDefault()
                        const reset = new URLSearchParams('');
                        handleParams(reset)
                        setShowCount(0)
                    }}>
                        Återställ filter
                </a>
            }
        </div>
    )
}

export default MobileFilter